<template>
  <el-dialog :visible="isLogin" :modal="isLogin" :show-close="false" class="dialog-box dialog-login dialog-login-diff">
    <div class="el-dialog__header el-dialog__header-diff">
      <span class="el-dialog__title" :class="activeIndex == index ?'is-active':''" v-for="(item,index) in titleList" :key="index" @click="changeLoginType(index)">
        {{item}}
        <div class="active-line" v-if="activeIndex == index"></div>
      </span>
    </div>
    <img src="../assets/images/tuoyuan.png" alt="背景图" class="dialog-img">
    <img src="../assets/images/close.png" alt="关闭" @click="loginHandler(false)">
    <el-form :model="ruleForm" ref="ruleForm" :rules="rules" :label-width="formLabelWidth" v-show="activeIndex == '1'">
      <el-form-item label="手机号：" prop="phone">
        <el-input v-model="ruleForm.phone" autocomplete="off" placeholder="请输入手机号" @input="loginValidateFn1"></el-input>
      </el-form-item>
      <el-row type="flex" justify="space-between">
        <el-form-item label="验证码：" class="dialog-input" prop="code">
          <el-input v-model="ruleForm.code" autocomplete="off" placeholder="请输入验证码" @input="loginValidateFn1"></el-input>
        </el-form-item>
        <el-button @click="sendSmsHandler" v-if="showTime">获取验证码</el-button>
        <el-button v-else disabled style="padding: 0;text-align: center;">{{count}}s后重新获取</el-button>
      </el-row>
    </el-form>
    <el-form :model="ruleForm1" ref="ruleForm1" :rules="rules1" v-show="activeIndex == '0'" class="el-form-diff">
      <el-form-item label="用户名：" :label-width="formLabelWidth" prop="user_name">
        <el-input v-model="ruleForm1.user_name" autocomplete="off" placeholder="请输入用户名" @input="loginValidateFn"></el-input>
      </el-form-item>
      <el-form-item label="密码：" :label-width="formLabelWidth" prop="password">
        <el-input v-model="ruleForm1.password" autocomplete="off" placeholder="请输入密码" :type="passwordType" @input="loginValidateFn">
          <template slot="append">
            <img :src="passwordImg[passwordType]" @click="changeShowPassword">
          </template>
        </el-input>
      </el-form-item>
      <el-form-item class="diff-form-item">
        <div id="geetest"></div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="loginForm" :class="btnActive?'button-active':''">登录</el-button>
    </div>
    <div class="register-box">
      <span @click="forgetPassword">忘记密码</span>
      <span>|</span>
      <span @click="goRegister">注册</span>
      <!-- <span>|</span>
      <span @click="goSclLogin">校园端用户登录</span> -->
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { sendSms, geetest } from "@/api/user";
import { randomToken } from "@/utils/auth.js";
export default {
  name: "Login",
    data() {
      const validateUserName = (rule, value, callback) => {
        sessionStorage.getItem('user_name', value)
        if (value.length === 0) {
          callback(new Error("请输入用户名"));
        } else {
          callback();
        }
      };
      const validateCode = (rule, value, callback) => {
        sessionStorage.getItem('password', value)
        if (value === '') {
          callback(new Error('请输入验证码'));
        } else {
          callback();
        }
      };
      const validatePhone = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error("请输入手机号"));
        } else {
          if ((/^1[34578]\d{9}$/.test(value))) {
            callback();
          } else {
            callback(new Error("请输入正确的手机号"));
          }
        }
      };
      const validatePassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          this.ruleForm1.password = value
          callback();
        }
      };
      return {
        formLabelWidth: '76px',
        ruleForm: {
          phone: '',
          code: ''
        },
        ruleForm1: {
          user_name: '',
          geetest_challenge: '',
          geetest_seccode: '',
          geetest_validate: '',
          password: ''
        },
        passwordImg:{
          "text": require("../assets/images/show.png"),
          "password": require("../assets/images/hidden.png"),
        },
        passwordType: 'password',
        passwordStr: false,
        smsToken: '',
        count: '',
        timer: null,
        showTime: true,
        rules: {
          phone: [
            { validator: validatePhone, trigger: 'blur' }
          ],
          code: [
            { validator: validateCode, trigger: 'blur' }
          ],
        },
        rules1: {
          user_name: [
            { validator: validateUserName, trigger: 'blur' }
          ],
          password: [
            { validator: validatePassword, trigger: 'blur' }
          ],
        },
        activeIndex: '0',
        titleList: ["密码登录","短信登录"],
        showValidStr: false,
        btnActive: false
      };
    },
    computed: {
      ...mapState({
          isLogin: state => state.user.isLogin,
          login_count: state => state.user.login_count,
          loginError: state => state.user.loginError
      })
    },
    watch: {
      loginError(val) {
        if(val) {
          this.resetInit()
        }
      },
      activeIndex(val) {
        if(val == '0' && this.ruleForm1.geetest_challenge) {
          this.resetInit()
        }
      }
    },
    mounted() {
      this.initGeetest()
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields();
        this.$refs.ruleForm1.resetFields();
      })
    },
    methods: {
      loginHandler(isLogin) {
          this.$store.commit("user/LOGINSTATUS",isLogin);
      },
      sendSmsHandler() {
        this.smsToken = randomToken(32);
        sendSms(this.ruleForm.phone,this.smsToken).then((res) => {
          if(res.status != 200) {
            this.$message({
                message: res.message,
                type: 'error'
            });
          } else {
            const TIME_COUNT = 179;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.showTime = false;
              this.timer = setInterval(() => {
                if (this.count > 1 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.showTime = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000)
            }  
          }
        })
      },
      showValid() {
        this.showValidStr = true;
      },
      resetInit() {
        this.btnActive = false
        this.initGeetest()
      },
      initGeetest() {
        let self = this
        geetest().then(res => {
          initGeetest({
            gt: res.data.gt,
            challenge: res.data.challenge,
            offline: !res.data.success,
            new_captcha: true,
            product: 'popup',
            width: "100%",
          }, function (captchaObj) {
            let geetest = document.getElementById("geetest")
            geetest.innerHTML = ''
            self.ruleForm1.geetest_challenge = ''
            self.ruleForm1.geetest_seccode = ''
            self.ruleForm1.geetest_validate = ''
            captchaObj.reset()
            captchaObj.appendTo('#geetest')
            captchaObj.onSuccess(function () {
              const result = captchaObj.getValidate()
              self.ruleForm1.geetest_challenge = result.geetest_challenge,
              self.ruleForm1.geetest_seccode = result.geetest_seccode,
              self.ruleForm1.geetest_validate = result.geetest_validate
              self.loginValidateFn()
            })
          })
        }).catch(err => {

        })
      },
      loginValidateFn() {
        if(this.ruleForm1.geetest_challenge && this.ruleForm1.user_name && this.ruleForm1.password) {
          this.btnActive = true
        } else if(this.ruleForm1.geetest_challenge && sessionStorage.getItem('username') && sessionStorage.getItem('password')) {
          this.ruleForm1.user_name = sessionStorage.getItem('user_name')
          this.ruleForm1.password = sessionStorage.getItem('password')
          this.btnActive = true
        } else {
          this.btnActive = false
        }
      },
      loginValidateFn1() {
        if(this.ruleForm.code && (/^1[34578]\d{9}$/.test(this.ruleForm.phone)) && this.smsToken) {
          this.btnActive = true
        } else {
          this.btnActive = false
        }
      },
      loginForm() {
        if(this.activeIndex == '0') {
          if(!this.ruleForm1.geetest_challenge) {
            return
          }
          this.$refs.ruleForm1.validate((valid) => {
            if(valid) {
              this.$store.dispatch('user/LOGINPASSWORD',{
                user_name: this.ruleForm1.user_name,
                password: this.ruleForm1.password,
                geetest_challenge: this.ruleForm1.geetest_challenge,
                geetest_seccode: this.ruleForm1.geetest_seccode,
                geetest_validate: this.ruleForm1.geetest_validate
              }).then((res) => {
                if(!res) {
                  this.resetInit()
                }
              }).catch(error => {
                  this.resetInit()
                  this.$message.error(error);
              })
            }
          })
        } else if(this.activeIndex == '1'){
          if(!this.ruleForm.phone || !this.ruleForm.code || !this.smsToken) {
            return
          }
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              this.$store.dispatch('user/LOGIN',{
                phone: this.ruleForm.phone,
                code: this.ruleForm.code,
                smsToken: this.smsToken
              }).then((res) => {
              }).catch(error => {
                  this.$message.error(error);
              })
            } else {
              return false;
            }
          });
        }
      },
      changeLoginType(index) {
        this.activeIndex = index;
        this.$nextTick(() => {
          this.$refs.ruleForm.resetFields();
          this.$refs.ruleForm1.resetFields();
        })
      },
      changeShowPassword() {
        this.passwordStr = !this.passwordStr;
        this.passwordType = this.passwordStr ? 'text' : 'password';
      },
      goRegister() {
        this.$store.commit('user/LOGINSTATUS', false);
        this.$store.commit('user/REGISTER', true);
      },
      forgetPassword() {
        this.$store.commit('user/LOGINSTATUS', false);
        this.$store.commit('user/FORGET', true);
      },
      goSclLogin() {
        this.$store.commit('user/LOGINSTATUS', false);
        this.$store.commit('user/SClUSERLOGIN', true);
      }
    }
  }
</script>

<style lang='scss' scoped>
  @import "@/assets/css/variables.scss";
  .dialog-box {
    img {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 40px;
      top: 40px;
    }
    .active-line {
      width: 32px;
      height: 4px;
      background: $common-color;
      border-radius: 2px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 15px;
    }
    .dialog-footer {
      padding: 0;
      button {
        width: 496px;
        height: 52px;
        border-radius: 8px;
        margin: 0 auto;
        font-size: 18px!important;
        background: #f0f2f5!important;
        border: none!important;
        position: absolute;
        bottom: 86px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 999;
        color: #c4c7cc!important;
      }
      .button-active {
        background: linear-gradient(90deg,#ffa94a, #ff913c)!important;
        color: #ffffff!important;
      }
    }
    .register-box {
      position: absolute;
      bottom: 40px;
      right: 40px;
      span {
        font-size: 16px;
        font-weight: 400;
        color: #5e6166;
        cursor: pointer;
      }
      span:hover {
        color: $common-color;
      }
      span:nth-child(2n) {
        padding: 0 8px;
      }
    }
    .diff-form-item {
      background: none!important;
      border: none!important;
      line-height: 0px!important;
      padding: 0px!important;
      height: 44px!important;
    }
  }
</style>